import { useContext } from "react"
import UserActionAuditTrailContext from "../UserActionAuditTrailContext"

const useUserActionAuditTrailContext = () => {
  const providedValue = useContext(UserActionAuditTrailContext)

  return { ...providedValue }
}

export default useUserActionAuditTrailContext
